import React from "react";
import StockStatusTag from "./stock-status-tag";

// Hiển thị 1 sản phẩm: ảnh + tên + giá + shop + trạng thái. Dùng trong form preview & dòng mở rộng bảng.
function formatPrice(price) {
    if (price == null) return "-";
    return new Intl.NumberFormat("vi-VN").format(price) + "đ";
}

function VideoProductPreview({ product }) {
    if (!product) return null;
    return (
        <div className="flex gap-3 items-center border rounded p-2 bg-surface-sunken">
            <img
                src={product.imageUrl || ""}
                alt=""
                className="w-14 h-14 object-cover rounded bg-surface-raised flex-shrink-0"
                onError={(e) => {
                    e.currentTarget.style.visibility = "hidden";
                }}
            />
            <div className="flex-1 min-w-0">
                <div className="font-medium truncate">
                    {product.productName || "(chưa lấy được tên)"}
                </div>
                <div className="text-xs text-content-3 truncate">
                    {product.shopName || "-"}
                    {product.itemId ? ` · ID ${product.itemId}` : ""}
                </div>
                <div className="flex gap-2 items-center mt-1">
                    <span className="text-red-600 font-semibold text-sm">
                        {formatPrice(product.price)}
                    </span>
                    <StockStatusTag status={product.status} />
                    {product.productLink && (
                        <a
                            href={product.productLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:underline text-xs"
                        >
                            Mở
                        </a>
                    )}
                </div>
            </div>
        </div>
    );
}

export default VideoProductPreview;
